import Vue from "vue";
import Vuetify from "vuetify/lib";
import pl from "vuetify/lib/locale/pl";
import "../theme/default.styl";
import { Ripple } from "vuetify/lib/directives"; // Fix due to used vuetify-upload-button

Vue.use(Vuetify, {
  theme: {
    primary: "#002A3A",
    secondary: "#424242",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  },
  customProperties: true,
  // iconfont: "fa4",
  lang: {
    locales: {
      pl
    },
    current: process.env.VUE_APP_LANG
  },
  directives: {
    Ripple
  }
});
